'use strict';

angular.module('pmtPlacesApp.services').service('pmtLocationDataService', [
	'$q',
	'$http',
	function ($q, $http) {
		let promise = null;
		const subscriptions = [];

		const locationFilter = (site, placeId) => s => s.site === site && s.placeId === placeId;
		const subExistsFilter = (site, placeId, subKey) => s =>
			s.site === site && s.placeId === placeId && s.subKey === subKey;

		const get = (site, placeId, options = { emit: true }) => {
			promise = $http.get(`api/${encodeURI(site)}/place/${placeId}`);
			const currentLocation = locationFilter(site, placeId);

			if (options.emit) {
				subscriptions.filter(currentLocation).map(sub => promise.then(sub.callback));
			}

			return promise;
		};

		const subscribe = (site, placeId, subKey, callback) => {
			const subExists = subExistsFilter(site, placeId, subKey);

			if (!subscriptions.find(subExists)) {
				subscriptions.push({ site: site, placeId: placeId, subKey: subKey, callback: callback });
			}

			if (promise) {
				promise.then(callback);
			}
		};

		const emit = (site, placeId, obj) => {
			const currentLocation = locationFilter(site, placeId);
			subscriptions.filter(currentLocation).map(sub => sub.callback(obj));
		};

		return {
			get: get,
			emit: emit,
			subscribe: subscribe
		};
	}
]);
